import TranslationText from '@Components/Utilities/TranslationText';
import RegistrationForm from '@Components/Forms/RegistrationForm';

const RegistrationView = (props) => {
    return (
        <div className='registration__container'>
            <div className='breadcrumbs'>
                <a className='breadcrumbs__link uppercase' href={props.BreadCrumbHomeRoute}><TranslationText tKey='sandhills.tradepubwebsite.mvc.home' />&nbsp;&gt;&nbsp;</a>
                <a className='breadcrumbs__link uppercase'><TranslationText tKey='sandhills.tradepubwebsite.mvc.registration' /></a>
            </div>
            <RegistrationForm {...props} />
        </div>
    );
};

export default RegistrationView;
global.RegistrationView = RegistrationView;